/* eslint-disable @typescript-eslint/no-unused-vars */
// import { IPaginationCustom } from 'shared/hooks/usePagination';
// import { AuthorProfileFilter } from 'pages/Authors/Profile/ProfileContainer';
import React from 'react';

const AsyncPublicationListProfile = React.lazy(() => import('./ListContainer'));
export const PublicationListProfile = () => {
  return <AsyncPublicationListProfile />;
};
